import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import {Link, useHistory, useParams} from "react-router-dom";
import axios from "axios";
import {CONFIRM_FICHE, DOWNLOAD_FICHE_RESUME, FIND_FICHE_BY_CODE} from "../../../api/Api";
import {addHttpPrefix, convertToLocalState, getFileUrl} from "../../../utils/helpers";
import CircularProgress from "@material-ui/core/CircularProgress";
import BootstrapLoadingButton from "../../../components/Ui/BootstrapLoadingButton";
import moment from 'moment'

import {ExpansionPanel as Accordion} from '@material-ui/core';
import {ExpansionPanelSummary as AccordionSummary} from '@material-ui/core';
import {ExpansionPanelDetails as AccordionDetails} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GoogleMapsComponent from "../../../components/Ui/GoogleMapsComponent";
import {societes} from "../../../utils/constants";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import fileDownload from "js-file-download";
import Divider from "@material-ui/core/Divider";
import {toast} from "react-toastify";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        [theme.breakpoints.down('sm')]: {
            padding: theme.spacing(1, 1)
        },
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(5, 12)
        },
        [theme.breakpoints.up('lg')]: {
            padding: theme.spacing(10, 20)
        },
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    table: {
        minWidth: 700,
    },

    accordionRoot: {
        '&.MuiExpansionPanel-root:before': {
            display: 'none',
            '& *':{
                boxShadow: 'none!important'
            }
        },
        '&.MuiExpansionPanel-root': {
            boxShadow: 'none!important',
            background: 'none!important'
        },
        '& .MuiExpansionPanelDetails-root > div': {
            background: 'white',
            padding: theme.spacing(4,4),
            margin: theme.spacing(0,1),
            borderRadius: 8,
            border: 'solid gray 1px'
        }
    },
}));


export default function (props) {

    const classes = useStyles();

    const {ficheCode} = useParams();
    const history = useHistory();

    const [ficheDetails, setFicheDetails] = React.useState();
    const [isLoadingDetails, setIsLoadingDetails] = React.useState();
    const [isInConfirmation, setIsInConfirmation] = React.useState();
    const [ficheNotFound, setFicheNotFound] = React.useState(false);

    const [isExporting,setIsExporting] = React.useState(false);


    async function loadDetails() {

        try {

            setIsLoadingDetails(true);

            const response = await axios.get(
                `${FIND_FICHE_BY_CODE}`,
                {
                    params: {
                        code: ficheCode
                    }
                }
            );

            setFicheDetails(response.data);

        } catch (e) {

            if (e.response && e.response.status === 404)
                toast.error('Aucune demande trouvé', {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        } finally {
            setIsLoadingDetails(false);
        }

    }

    async function confirmFiche() {

        try {

            setIsInConfirmation(true);

            const response = await axios.get(
                `${CONFIRM_FICHE}/${ficheDetails.id}`,
                {
                }
            );

            toast.success('Votre demande a bien été confirmée avec succès', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            window.location.href = '/';

        } catch (e) {

            if (e.response && e.response.status === 404)
            toast.error('Aucune demande trouvé', {
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });

            if (e.response && e.response.status === 400)
                toast.error(e.response.data.errors.message, {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

        } finally {
            setIsInConfirmation(false);
        }

    }

    const localState = React.useMemo(
        () => {
            if (ficheDetails) {
                let localState = convertToLocalState(ficheDetails.state);
                return localState;
            }
        }, [ficheDetails]
    )


    React.useEffect(() => {

        loadDetails();

    }, [])


    async function downloadFicheResume(){

        try{

            setIsExporting(true);

            const response = (await axios.get(
                `${DOWNLOAD_FICHE_RESUME}/${ficheDetails.id}`,
                {
                    responseType: 'blob'
                }
            ));

            fileDownload(response.data, `PGT_${ficheDetails.code}.pdf`);
        } catch (e) {
            console.log(e);
        } finally {
            setIsExporting(false);
        }


    }


    return (
        <div>

        {
            (

                <div className={`${classes.root} bg-white`}>

                    <div>

                        <div className={'h3 font-weight-bold text-primary mb-5'}>

                            Récapitulatif de la fiche

                        </div>



                        <div>
                                <BootstrapLoadingButton isLoading={isExporting} onClick={downloadFicheResume} className={'btn btn-light-success'}>
                                    <i className={'flaticon2-download'}></i> <span className="d-inline-block mr-3">
                                        Télécharger le récapitulatif
                                    </span>
                                </BootstrapLoadingButton>
                            </div>

                    </div>

                    <div>
                        {
                            isLoadingDetails && (
                                <CircularProgress/>
                            )
                        }
                    </div>

                    {
                        ficheDetails && (

                            <div className={'mt-5'}>



                                <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >

                                        <div className={'h3 font-weight-bold w-100'}>
                                            <div className="mb-5">Contacts</div>

                                            <div className="float-right">
                                                <Link
                                                    to={`/fiches/create?formCode=${ficheDetails.form_code}&step=3`}
                                                    className={'btn btn-light-primary'}>
                                                    Modifier cette section
                                                </Link>
                                            </div>

                                            <Divider />
                                        </div>


                                    </AccordionSummary>
                                    <AccordionDetails>

                                        <div className={'row'}>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Type du client
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.type_client_data?.libelle}
                                            </div>

                                            {
                                                ficheDetails.type_client_id === 1 && (
                                                    <>

                                                        <div className={'col-6'}>

                                                            <div className={'underlined font-weight-light my-3'}>
                                                                Nom & Prénoms
                                                            </div>

                                                        </div>

                                                        <div className={'h5 col-6'}>
                                                            {ficheDetails.nom} {ficheDetails.prenoms}
                                                        </div>

                                                    </>
                                                )
                                            }


                                            {
                                                [2,3].includes(ficheDetails.type_client_id) && (
                                                    <>

                                                        <div className={'col-6'}>

                                                            <div className={'underlined font-weight-light my-3'}>
                                                                Raison sociale
                                                            </div>

                                                        </div>

                                                        <div className={'h5 col-6'}>
                                                            {ficheDetails.raison_sociale}
                                                        </div>

                                                    </>
                                                )
                                            }

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Email
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.email}
                                            </div>


                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Numéro de téléphone
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.mobile}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Second Numéro de téléphone
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.mobile_2}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Siège social de l'entreprise
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.siege_sociale}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Nom de l'entreprise
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.nom_enterprise}
                                            </div>


                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Nom du sous traitant
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.nom_sous_traitant}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Nom du responsable chantier
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.nom_prenoms_responsable_chantier}
                                            </div>


                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Contact du responsable chantier
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.contact_responsable_chantier}
                                            </div>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>
                                                    Informations supplémentaires
                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.informations_supplementaire}
                                            </div>

                                        </div>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >

                                        <div className={'h3 font-weight-bold w-100'}>
                                            <div className="mb-5">Description</div>

                                            <div className="float-right">
                                                <Link
                                                    to={`/fiches/create?formCode=${ficheDetails.form_code}&step=0`}
                                                    className={'btn btn-light-primary'}>
                                                    Modifier cette section
                                                </Link>
                                            </div>

                                            <Divider />
                                        </div>

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className={'row'}>

                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Type de la demande

                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {societes[ficheDetails.type_travaux]}
                                            </div>


                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Objet de la demande

                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>

                                                {[...ficheDetails.nature_travaux_data.map(item => item.libelle), ficheDetails.autre_cie, ficheDetails.autre_sodeci]
                                                    .filter(item=>!!item).map(
                                                        (item, index) => {
                                                            if (index === ficheDetails.nature_travaux_data.length)
                                                                return item;

                                                            return item + ', ';
                                                        }
                                                    )}
                                            </div>



                                            <div className={'col-6'}>

                                                <div className={'underlined font-weight-light my-3'}>

                                                    Description des travaux

                                                </div>

                                            </div>

                                            <div className={'h5 col-6'}>
                                                {ficheDetails.description_travaux}
                                            </div>


                                            {(
                                                ficheDetails.type_travaux == 1 ||
                                                ficheDetails.type_travaux == 3) && (
                                                <>

                                                    <div className={'col-6'}>

                                                        <div className={'underlined font-weight-light my-3'}>

                                                            Techniques des travaux

                                                        </div>

                                                    </div>

                                                    <div className={'h5 col-6'}>

                                                    {ficheDetails.technique_travaux_data.map(
                                                                item => {
                                                                    return item.libelle
                                                                }
                                                            ).join(', ')}
                                                    </div>

                                                    <div className={'col-6'}>

                                                        <div className={'underlined font-weight-light my-3'}>

                                                            Type de terrassement

                                                        </div>

                                                    </div>

                                                    <div className={'h5 col-6'}>
                                                    {ficheDetails.technique_terrassement_type.join(', ')}
                                                    </div>

                                                    <div className={'col-6'}>

                                                        <div className={'underlined font-weight-light my-3'}>
                                                            Hauteur | Profondeur
                                                        </div>

                                                    </div>

                                                    <div className={'row col-6 font-weight-bold'}>

                                                        <table className="table table-bordered">

                                                            <thead>
                                                            <tr>
                                                                {
                                                                    ficheDetails.hauteurs.remblai && (
                                                                        <td>Remblai</td>
                                                                    )
                                                                }
                                                                {
                                                                    ficheDetails.hauteurs.deblai && (
                                                                        <td>Déblai</td>
                                                                    )
                                                                }
                                                                {
                                                                    ficheDetails.hauteurs.demolition && (
                                                                        <td>Démolition, Construction</td>
                                                                    )
                                                                }
                                                                {
                                                                    ficheDetails.hauteurs.fouille && (
                                                                        <td>Fouille</td>
                                                                    )
                                                                }
                                                            </tr>
                                                            </thead>
                                                            <tbody>
                                                            <tr>
                                                                {
                                                                    ficheDetails.hauteurs.remblai && (
                                                                        <td>{ficheDetails.hauteurs.remblai} m</td>
                                                                    )
                                                                }

                                                                {
                                                                    ficheDetails.hauteurs.deblai && (
                                                                        <td>{ ficheDetails.hauteurs.deblai } m</td>
                                                                    )
                                                                }
                                                                {
                                                                    ficheDetails.hauteurs.demolition && (
                                                                        <td>{ficheDetails.hauteurs.demolition} m</td>
                                                                    )
                                                                }
                                                                {
                                                                    ficheDetails.hauteurs.fouille && (
                                                                        <td>{ficheDetails.hauteurs.fouille} m</td>
                                                                    )
                                                                }
                                                            </tr>
                                                            </tbody>

                                                        </table>

                                                    </div>

                                                    <div className={'col-6'}>

                                                        <div className={'underlined font-weight-light my-3'}>

                                                            Moyens utilisés

                                                        </div>

                                                    </div>

                                                    <div className={'h5 col-6'}>
                                                        {[ficheDetails.moyens_utilises.map(item=>item.libelle), ficheDetails.moyen_utilise_travaux_autre].map(
                                                            (item, index) => {
                                                                if (index === ficheDetails.moyen_utilise_travaux.length)
                                                                    return item;

                                                                return item + ', ';
                                                            }
                                                        )}
                                                    </div>

                                                </>
                                            )
                                            }




                                            {
                                                [
                                                    ficheDetails.plan_implentation_travaux,
                                                ].filter(item => !!item).map(
                                                    anyy => {
                                                        return (
                                                            <>
                                                                <div className={'col-6'}>

                                                                    <div className={'underlined font-weight-light my-3'}>

                                                                        Fichier de plan d'implantation

                                                                    </div>

                                                                </div>

                                                                <div className={'h5 col-6'}>

                                                                    {
                                                                        ficheDetails.plan_implentation_travaux.map(
                                                                            item => {
                                                                                return (
                                                                                    <a href={getFileUrl(item.value)} target='_blank'
                                                                                       className={'btn btn-small btn-light-primary'}>
                                                                                        VOIR
                                                                                    </a>
                                                                                )
                                                                            }
                                                                        )
                                                                    }

                                                                    {
                                                                        ficheDetails.implantation_travaux_files_link && (
                                                                            <div>

                                                                                <a href={addHttpPrefix(ficheDetails.implantation_travaux_files_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.implantation_travaux_files_link)}</a>

                                                                            </div>
                                                                        )
                                                                    }



                                                                </div>

                                                            </>
                                                        )
                                                    }
                                                )
                                            }


                                        </div>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >

                                        <div className={'h3 font-weight-bold w-100'}>
                                            <div className="mb-5">Localisation</div>

                                            <div className="float-right">
                                                <Link
                                                    to={`/fiches/create?formCode=${ficheDetails.form_code}&step=1`}
                                                    className={'btn btn-light-primary'}>
                                                    Modifier cette section
                                                </Link>
                                            </div>

                                            <Divider />
                                        </div>

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className={'w-100'}>

                                            <div className="row">

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Equipement CIE/SODECI le plus proche

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {ficheDetails.adresse_equipement_cie_proche}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Zone des travaux

                                                    </div>

                                                </div>

                                                <div className="col-6">

                                                    {
                                                        ficheDetails.zone_travaux_file && (

                                                            <a
                                                                target={'_blank'}
                                                                href={getFileUrl(ficheDetails.zone_travaux_file)} className={'btn btn-small btn-light-primary'}>
                                                                VOIR
                                                            </a>

                                                        )
                                                    }
                                                    {
                                                        !ficheDetails.zone_travaux_file && (
                                                            <span>-</span>
                                                        )
                                                    }

                                                    {
                                                        ficheDetails.zone_travaux_file_link && (
                                                            <div>

                                                                <a href={addHttpPrefix(ficheDetails.zone_travaux_file_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.zone_travaux_file_link)}</a>

                                                            </div>
                                                        )
                                                    }

                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Villes

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {ficheDetails.villes.map(
                                                        (item,index) => {

                                                            if(index == ficheDetails.villes.length - 1)
                                                                return item.libelle;

                                                            return item.libelle + ', '
                                                        }
                                                    )}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Communes

                                                    </div>

                                                </div>

                                                <div className={'col-6 h5'}>
                                                    {ficheDetails.communes.map(
                                                        (item,index) => {

                                                            if(index == ficheDetails.communes.length - 1)
                                                                return item.libelle;

                                                            return item.libelle + ', '
                                                        }
                                                    )}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Quartiers

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {ficheDetails.quartiers.map(
                                                        (item,index) => {

                                                            if(index == ficheDetails.quartiers.length - 1)
                                                                return item.libelle;

                                                            return item.libelle + ', '
                                                        }
                                                    )}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Rues

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {ficheDetails.rue}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Description localisation

                                                    </div>

                                                </div>

                                                <div className="h5 col-6">
                                                    {ficheDetails.description_localisation}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Fichiers numériques de plan d'ouvrage

                                                    </div>

                                                </div>

                                                <div className="h5 col-6">

                                                    {
                                                        ficheDetails.fichiers_numerique_ouvrage.map(
                                                            item => {
                                                                return (
                                                                    <a href={getFileUrl(item.value)} target='_blank'
                                                                       className="btn btn-small btn-light-primary">
                                                                        VOIR
                                                                    </a>
                                                                );
                                                            }
                                                        )
                                                    }

                                                    {
                                                        ficheDetails.ouvrages_numeriques_files_link && (
                                                            <div>

                                                                <a href={addHttpPrefix(ficheDetails.ouvrages_numeriques_files_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.ouvrages_numeriques_files_link)}</a>

                                                            </div>
                                                        )
                                                    }


                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Description localisation

                                                    </div>

                                                </div>


                                                <div className="h5 col-6">
                                                    <GoogleMapsComponent
                                                        markers={ficheDetails.lat_lng}
                                                    />
                                                </div>

                                            </div>

                                        </div>
                                    </AccordionDetails>
                                </Accordion>

                                <Accordion className={classes.accordionRoot} defaultExpanded={true}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon/>}
                                        aria-controls="panel1a-content"
                                        id="panel1a-header"
                                    >

                                        <div className={'h3 font-weight-bold w-100'}>
                                            <div className="mb-5">Période</div>

                                            <div className="float-right">
                                                <Link
                                                    to={`/fiches/create?formCode=${ficheDetails.form_code}&step=2`}
                                                    className={'btn btn-light-primary'}>
                                                    Modifier cette section
                                                </Link>
                                            </div>

                                            <Divider />
                                        </div>

                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div className={'w-100'}>
                                            <div className="row">

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Date de début des travaux

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {moment(ficheDetails.date_debut_travaux).format('DD/MM/YYYY')}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Date de fin des travaux

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {moment(ficheDetails.date_fin_travaux).format('DD/MM/YYYY')}
                                                </div>

                                                <div className={'col-6'}>

                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Informations supplémentaires

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>
                                                    {ficheDetails.informations_supplementaire_periode}
                                                </div>

                                                <div className="col-6">


                                                    <div className={'underlined font-weight-light my-3'}>

                                                        Fichiers de planning des travaux

                                                    </div>

                                                </div>

                                                <div className={'h5 col-6'}>

                                                    {
                                                        ficheDetails.planning_travaux.map(
                                                            item => {
                                                                return (
                                                                    <a href={getFileUrl(item.value)} target='_blank'
                                                                       className="btn btn-small btn-light-primary">
                                                                        VOIR
                                                                    </a>
                                                                );
                                                            }
                                                        )
                                                    }

                                                    {
                                                        ficheDetails.planning_travaux_file_link && (
                                                            <div>

                                                                <a href={addHttpPrefix(ficheDetails.planning_travaux_file_link)} target={'_blank'}>{addHttpPrefix(ficheDetails.planning_travaux_file_link)}</a>

                                                            </div>
                                                        )
                                                    }


                                                </div>

                                            </div>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>


                                {
                                    ficheDetails && ficheDetails.state == 'App\\Models\\Fiches\\States\\WaitingUserConfirmationStep' && (

                                        <ConfirmationModal
                                            title={'Confirmation'}
                                            negativeText={'Annuler'}
                                            positiveText={'Valider'}
                                            text={'Votre demande va être transférée à nos agents pour analyse et traitement, vous ne serez plus en mesure de modifier les informations fournies, êtes vous sûr de vouloir continuer ?' }
                                            onConfirm={()=>{
                                                confirmFiche();
                                            }}>

                                            <BootstrapLoadingButton
                                                isLoading={isInConfirmation}
                                                className={'btn btn-light-success d-block w-100'}
                                            >
                                                Confirmer ma demande
                                            </BootstrapLoadingButton>

                                        </ConfirmationModal>

                                    )
                                }
                            </div>

                        )
                    }

                </div>


            )
        }

    </div>

    );


}